import React, { RefObject, useState } from 'react';
import styles from './Notifications.module.scss';
import { Stack } from 'new/elements/Stack';
import { PillTabs } from 'new/elements/PillTabs';
import { PillTab } from 'new/elements/PillTabs/PillTabs';
import { List } from 'new/elements/Notifications/List';
import { Settings } from 'new/elements/Notifications/Settings';

interface NotificationsProps {
  notificationType: string;
  resourceId: string;
  parentScrollRef?: RefObject<any>;
}

const tabs = [
  {
    value: 'all',
    label: 'All Notifications',
  },
  {
    value: 'settings',
    label: 'Notifications settings',
  },
] as PillTab[];

const Components = {
  all: List,
  settings: Settings,
};

export const Notifications = (props: NotificationsProps) => {
  const { resourceId, notificationType, parentScrollRef } = props;
  const [tab, setTab] = useState('all');

  const handleTabChange = (tab) => {
    setTab(tab);
  };

  const Component = Components[tab] || Components.all;

  return (
    <Stack>
      <Stack alignItems="center" className={styles.pillTabs}>
        <PillTabs tabs={tabs} onSelectionChange={handleTabChange} selected={tab} />
      </Stack>
      <Component
        resourceId={resourceId}
        resourceType={notificationType}
        parentScrollRef={parentScrollRef}
      />
    </Stack>
  );
};
